import { Button, Drawer } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { WithFooterWrapper } from '~/components/with-footer-wrapper/WithFooterWrapper';
import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { useCompetitorsData } from '~/widgets/knowledge-graph-widget/hooks/useCompetitorsData';

import { CompetitorsWidget } from '../competitors-widget/CompetitorsWidget';
import { useCompetitorsDrawer } from './useCompetitorsDrawer';

export interface CompetitorsDrawerProps {
  entity: Entity;
}

export const CompetitorsDrawer = ({ entity }: CompetitorsDrawerProps) => {
  const { t } = useTranslation(['widget']);
  const { navigateToPage } = useNavigateToAssetOverview();
  const { closeDrawer, isDrawerOpen, competitorTag } = useCompetitorsDrawer();

  const { selectedCompetitor, competitorsByTag } = useCompetitorsData({
    entityTag: entity.tag,
  });

  if (!selectedCompetitor) {
    return null;
  }

  const competitor = competitorsByTag[selectedCompetitor];

  if (!competitor) {
    return null;
  }

  return (
    <Drawer
      data-testid="competitors-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        competitorTag ? (
          <Button
            variant="empty"
            size="xsmall"
            label={t('themeOverview.drawer.assetOverview')}
            iconName="Expand"
            onClick={() => navigateToPage({ entityTag: competitorTag })}
          />
        ) : null
      }
    >
      <WithFooterWrapper isWrappedComponentOpened={isDrawerOpen}>
        <CompetitorsWidget entity={entity} competitorData={competitor} />
      </WithFooterWrapper>
    </Drawer>
  );
};
